/**
 * Lazy-loaded route components.
 *
 * Secondary pages that are not part of the critical first-load path are loaded
 * on demand. This keeps the initial bundle (Home + FairLaunch + Create) small
 * while deferring wallet, legal, admin and studio pages until they are needed.
 *
 * Each lazy() call produces a separate async chunk that Vite code-splits at
 * build time.
 */
import { lazy } from "react";

// ── Legal / information pages ─────────────────────────────────────────────────
export const About            = lazy(() => import("./pages/About"));
export const Risk             = lazy(() => import("./pages/Risk"));
export const Terms            = lazy(() => import("./pages/Terms"));
export const Privacy          = lazy(() => import("./pages/Privacy"));
export const AcceptableUse    = lazy(() => import("./pages/AcceptableUse"));
export const CreatorRewards   = lazy(() => import("./pages/CreatorRewards"));
export const Networks         = lazy(() => import("./pages/Networks"));

// ── Extended legal documents ──────────────────────────────────────────────────
export const LegalIndex                  = lazy(() => import("./pages/legal/LegalIndex"));
export const UnauditedBeta               = lazy(() => import("./pages/legal/UnauditedBeta"));
export const NonAffiliation              = lazy(() => import("./pages/legal/NonAffiliation"));
export const SmartContractRisk           = lazy(() => import("./pages/legal/SmartContractRisk"));
export const ContentModeration           = lazy(() => import("./pages/legal/ContentModeration"));
export const ContractAddresses           = lazy(() => import("./pages/legal/ContractAddresses"));
export const CreatorRecipientImmutability = lazy(() => import("./pages/legal/CreatorRecipientImmutability"));
export const IncidentResponse            = lazy(() => import("./pages/legal/IncidentResponse"));
export const IrreversibleTransactions    = lazy(() => import("./pages/legal/IrreversibleTransactions"));
export const NoGuaranteedReturns         = lazy(() => import("./pages/legal/NoGuaranteedReturns"));

// ── Secondary product pages ───────────────────────────────────────────────────
export const MyLaunches       = lazy(() => import("./pages/MyLaunches"));
export const Recent           = lazy(() => import("./pages/Recent"));
export const TokenProfile     = lazy(() => import("./pages/TokenProfile"));
export const LaunchStudio     = lazy(() => import("./pages/LaunchStudio"));


// ── CCC Members Hub ───────────────────────────────────────────────────────────
export const PartnersCCC = lazy(() => import("./pages/PartnersCCC"));
export const MembersCCC  = lazy(() => import("./pages/MembersCCC"));
export const AdminCCC    = lazy(() => import("./pages/AdminCCC"));

// ── Admin ─────────────────────────────────────────────────────────────────────
export const AdminTeamAccess  = lazy(() => import("./pages/AdminTeamAccess"));

// ── Wallet (feature-flagged; disabled in production) ─────────────────────────
export const WalletHome         = lazy(() => import("./pages/wallet/WalletHome"));
export const WalletConnect      = lazy(() => import("./pages/wallet/WalletConnect"));
export const Portfolio          = lazy(() => import("./pages/wallet/Portfolio"));
export const TransactionCentre  = lazy(() => import("./pages/wallet/TransactionCentre"));
export const Send               = lazy(() => import("./pages/wallet/Send"));
export const Receive            = lazy(() => import("./pages/wallet/Receive"));
export const SecurityCentre     = lazy(() => import("./pages/wallet/SecurityCentre"));
export const NotificationCentre = lazy(() => import("./pages/wallet/NotificationCentre"));
